import HostVendorMix from './HostVendorMix';

export default HostVendorMix;
